import theme from 'theme'

const InstanceCheckedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M5.00049 8.50159L7.32798 10.8291C7.41723 10.9183 7.56581 10.9036 7.63581 10.7986L11.2505 5.37659M5.60059 2.10156H10.4006C12.3336 2.10156 13.9006 3.66857 13.9006 5.60156V10.4016C13.9006 12.3346 12.3336 13.9016 10.4006 13.9016H5.60059C3.66759 13.9016 2.10059 12.3346 2.10059 10.4016V5.60156C2.10059 3.66857 3.66759 2.10156 5.60059 2.10156Z"
      stroke={theme.colors.white}
      strokeLinecap="round"
    />
  </svg>
)

export default InstanceCheckedIcon
